export const getProductQuantityData = (
  productReference: any,
  productQuantity: any,
  nestIndex: number
) => {
  // If we have productSuborderContexts, use them to find the correct productQuantity
  if (
    productReference.productSuborderContexts &&
    Array.isArray(productReference.productSuborderContexts) &&
    productReference.productSuborderContexts.length > 0
  ) {
    const targetContext =
      productReference.productSuborderContexts[nestIndex] ||
      productReference.productSuborderContexts[0];

    if (targetContext) {
      const foundPQ = productQuantity.find(
        (pq) =>
          pq.productId === productReference.originalProductReference &&
          pq.suborderReference === targetContext.suborderReference &&
          pq.orderReference === targetContext.orderReference
      );

      return {
        foundPQ,
        orderedQuantity: targetContext.productQuantity,
        suborderReference: targetContext.suborderReference,
      };
    }
  }

  const currentSuborder = productReference.suborders?.find((suborder) =>
    suborder.suborderProducts?.find(
      (p) => p.reference === productReference.originalProductReference
    )
  );

  if (productReference.suborders?.length > 1) {
    const subordersWithProduct = productReference.suborders.filter((suborder) =>
      suborder.suborderProducts?.find(
        (p) => p.reference === productReference.originalProductReference
      )
    );

    subordersWithProduct.sort((a, b) => a.reference.localeCompare(b.reference));

    const targetSuborder =
      subordersWithProduct[nestIndex] || subordersWithProduct[0];

    const productFound = targetSuborder?.suborderProducts?.find(
      (p) => p.reference === productReference.originalProductReference
    );

    const foundPQ = productQuantity.find(
      (pq) =>
        pq.productId === productReference.originalProductReference &&
        pq.suborderReference === targetSuborder?.reference
    );

    return {
      foundPQ,
      orderedQuantity: productFound?.quantity,
      suborderReference: targetSuborder?.reference,
    };
  }

  const productFound = currentSuborder?.suborderProducts?.find(
    (p) => p.reference === productReference.originalProductReference
  );

  const foundPQ = productQuantity.find(
    (pq) =>
      pq.productId === productReference.originalProductReference &&
      pq.suborderReference === currentSuborder?.reference
  );

  return {
    foundPQ,
    orderedQuantity: productFound?.quantity,
    suborderReference: currentSuborder?.reference,
  };
};
